export const CRAWLER_TEMPLATE = "crawler";